define(['underscore', 'edge/platform/base/BaseCtrl'], (_, BaseCtrl)=> {
    const fn = (LocaleService, $filter, $scope, StateUtils, LoadSaveService, $window, submissionViewModel, EventHub)=> {
        const ctrl = Object.create(BaseCtrl);
        const flowModel = StateUtils.activeDataForState(true).flowModel;
        const submissionVM = submissionViewModel();

        ctrl.init = ()=> {
            const quoting = submissionVM.quoteData.value;
            $scope.page = {
                sessionUUID: submissionVM.sessionUUID.value,
                quoteID: submissionVM.quoteID.value,
            };

            $scope.page.standardQuotes = _.where(quoting.offeredQuotes, {isCustom: false});
            $scope.page.customQuotes = _.where(quoting.offeredQuotes, {isCustom: true});

            $scope.page.offeringLabels = ctrl._setOfferingLabels($scope.page.standardQuotes);
            $scope.page.baseOffering = ctrl._setBaseOffering($scope.page.standardQuotes);
        };

        ctrl.printQuote = ()=> {
            EventHub.publish('wizard', 'print');
            $window.print();
        };

        ctrl.setSelectedQuote = (quote)=> {
            if (quote.branchCode === 'CUSTOM' || quote.branchCode.indexOf('Version') === 0) {
                $scope.$broadcast('CustomQuoteSelected', [quote.publicID]);
            }
        };

        ctrl.getCustomQuoteHeaderCostString = ()=> {
            return `${LocaleService.getLocaleInfo().currency.symbol}?`;
        };

        ctrl.buy = (selectedQuote, numberOfPayments)=> {
            //stash some bind information in state data so it can be accessed later when we call the bind method
            StateUtils.activeDataForState(true).numberOfPayments = numberOfPayments;
            StateUtils.activeDataForState(true).chosenQuote = selectedQuote.publicID;
            flowModel.next(submissionVM);
        };

        ctrl._setOfferingLabels = (standardOfferings)=> {
            return _.map(standardOfferings, (offering)=> {
                return $filter('translate')(`quoteandbind.controllers.QuoteDetails.${offering.branchCode}`);
            });
        };

        ctrl._setBaseOffering = (standardOfferings)=> {
            if (angular.isArray(standardOfferings) && standardOfferings.length === 1) {
                return standardOfferings[0];
            } else if (angular.isArray(standardOfferings) && standardOfferings.length > 1) {
                return standardOfferings[1];
            }
        };

        return ctrl.create($scope);
    };
    fn.$inject = ['LocaleService', '$filter', '$scope', 'StateUtils', 'qnb.LoadSaveService', '$window', 'submissionViewModel', 'EventHub'];

    return fn;
});


// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/common/controllers/QuoteDetailsCtrl.js